import DOMPurify from 'dompurify'

/** HTML с договора / профиля: штамп, disclaimer, подпись-img, подсветка поиска. */
const DEFAULT_CONFIG = {
    ALLOWED_TAGS: [
        'img', 'div', 'span', 'p', 'br', 'strong', 'em', 'b', 'i', 'u',
        'a', 'hr', 'ul', 'ol', 'li', 'mark',
    ],
    ALLOWED_ATTR: [
        'src', 'alt', 'style', 'width', 'height', 'class',
        'href', 'target', 'rel',
    ],
    ALLOW_DATA_ATTR: false,
}

const SIGNATURE_CONFIG = {
    ALLOWED_TAGS: ['img'],
    ALLOWED_ATTR: ['src', 'alt', 'style', 'width', 'height'],
    ALLOW_DATA_ATTR: false,
}

function getPurify() {
    if (typeof window === 'undefined') {
        return null
    }
    // DOMPurify по умолчанию биндится при импорте; для jest/node передаём window явно.
    return typeof DOMPurify === 'function' ? DOMPurify(window) : DOMPurify
}

export function sanitizeUntrustedHtml(html: string): string {
    if (!html) {
        return ''
    }
    const purify = getPurify()
    if (!purify) {
        return ''
    }
    return purify.sanitize(html, DEFAULT_CONFIG)
}

/** Подпись хранится как `<img src=...>`. */
export function sanitizeSignatureHtml(html: string): string {
    if (!html) {
        return ''
    }
    const purify = getPurify()
    if (!purify) {
        return ''
    }
    return purify.sanitize(html, SIGNATURE_CONFIG)
}
